export const ALT_CTA_COPY = 'Get started'
